import React from 'react';
import WranglerApp from '../../submodules/wrangler/apps/wrangler/src/App';
import '../../submodules/wrangler/apps/wrangler/src/App.css';
import '../../submodules/wrangler/apps/wrangler/src/index.css';

function Wrangler() {
    return (
        <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
            <WranglerApp />
        </div>
    );
}

export default Wrangler;

